import React from 'react';
import { PROVIDER_OPTIONS } from '../../../../../constants/index';
import { useDispatch, useSelector } from 'react-redux';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';

export const ProviderFilter = ({ value, onChange, ...otherProps }) => {
  const selectedValue = PROVIDER_OPTIONS.filter((e) => e.value === value)[0];

  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );

  const { Provider } = allFilters;
  return (
    <AutoSuggestionSelectComponent
      placeholder={Provider === 'facility' ? 'Facilities' : 'Doctors'}
      options={PROVIDER_OPTIONS}
      components={{ IndicatorSeparator: () => null }}
      value={selectedValue}
      onChange={onChange}
      {...otherProps}
      isSearchable={false}
      //isDisabled={true}
      inputClassName="best-match-filter height-32"
    />
  );
};
